import { useEffect, useState } from "react";

function ImageFromJson({ apiUrl }) {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    fetch(apiUrl)
      .then((res) => res.json())
      .then((data) => {
        setImageUrl(data?.guid?.rendered);
      })
      .catch((err) => console.error("Error fetching image:", err));
  }, [apiUrl]);

  return (
    <div>
      {imageUrl ? (
        <img src={imageUrl} alt="From API" style={{ maxWidth: "100%" }} />
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default ImageFromJson;
